"use client";

import * as React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";

interface UserAvatarProps {
  name?: string | null;
  src?: string | null;
  className?: string;
  testId?: string;
}

/**
 * Single source of truth for user profile pictures across the app.
 * Falls back to initials on the brand color when no image is set.
 */
export function UserAvatar({ name, src, className, testId }: UserAvatarProps) {
  const initials = React.useMemo(() => {
    if (!name) return "?";
    const parts = name.trim().split(/\s+/).slice(0, 2);
    return parts.map((p) => p[0]?.toUpperCase() ?? "").join("") || "?";
  }, [name]);

  return (
    <Avatar className={cn("h-10 w-10", className)} data-testid={testId}>
      {src ? <AvatarImage src={src} alt={name ?? "User avatar"} /> : null}
      <AvatarFallback className="bg-[#27335D] text-white font-medium">
        {initials}
      </AvatarFallback>
    </Avatar>
  );
}
